import { Controller } from "@hotwired/stimulus"
import DirectoryTable from "../lib/directory_table"
import { DateTime } from "luxon"
import { emptyStatePlaceholder } from "./tabulator_helpers"

export default class extends Controller {
  static targets = ["table"]

  static values = {
    url: String,
    filtered: Boolean,
    tabulatorTable: Object,
  }

  connect() {
    let ajaxUrl = this.urlValue
    try {
      const u = new URL(this.urlValue, window.location.origin)
      u.searchParams.set("format", "json")
      ajaxUrl = u.toString()
    } catch (e) {}

    this.tabulatorTable = new DirectoryTable(this.tableTarget, {
      layout: "fitDataStretch",
      placeholder: emptyStatePlaceholder(
        this.filteredValue ? "No authentication events match these filters" : "No authentication events yet"
      ),
      // Both bounds make the table fit its rows, so a short page does not leave
      // an empty band between the last row and the pager.
      minHeight: 240,
      maxHeight: "calc(100vh - 180px)",
      ajaxURL: ajaxUrl,
      ajaxConfig: "GET",
      pagination: true,
      paginationMode: "remote",
      paginationSize: 50,
      paginationCounter: "rows",
      paginationSizeSelector: [50, 100, 300],
      dataSendParams: { page: "page", size: "length" },
      ajaxResponse: (url, params, response) => ({
        data: response.data,
        last_page: response.last_page,
        last_row: response.last_row,
      }),
      columnDefaults: { headerSort: false },
      columns: [
        {
          title: "When",
          field: "occurred_at",
          formatter: "datetime",
          formatterParams: {
            inputFormat: "iso",
            outputFormat: "MMM d, yyyy 'at' t",
            invalidPlaceholder: "—",
            timezone: "America/Los_Angeles",
          },
        },
        {
          title: "User",
          field: "user_name",
          formatter: (cell) => {
            const value = cell.getValue()
            const url = cell.getRow().getData().user_url
            if (!url) return value
            return `<a href="${url}" class="link">${value}</a>`
          },
        },
        { title: "Type", field: "event_type" },
        { title: "Outcome", field: "outcome" },
        { title: "Device", field: "device" },
        // API-token calls have no browser device; they carry the issuing token
        // and the capability that was called instead.
        {
          title: "API Client",
          field: "api_client",
          formatter: (cell) => {
            const value = cell.getValue()
            if (!value) return "—"
            const capability = cell.getRow().getData().capability
            return capability
              ? `${value}<div class="text-xs paper-table-muted">${capability}</div>`
              : value
          },
        },
        { title: "IP", field: "ip_address" },
        { title: "Summary", field: "summary_text", widthGrow: 2 },
      ],
      dependencies: {
        DateTime: DateTime,
      },
    })
  }

  disconnect() {
    this.tabulatorTable?.destroy()
    this.tabulatorTable = null
  }
}
